//Imports node_modules
import React from "react"
import ButtonAdvanced from "../../buttonAdvanced/ButtonAdvanced"

//Imports Css
import './NextButton.css'

//Imports Components

//Botão que procede para a operação seguinte
const NextButton = (params) => {

    //--- Variaveis

    //Variaveis locais
    let classes = 'nextBtn '
    classes += params.blue ? 'blue ' : ''
    classes += params.green ? 'green ' : ''
    classes += params.purple ? 'purple ' : ''
    classes += params.red ? 'red ' : ''

    classes += params.blue && params.isDisabled ? 'blueDisabled ' : ''
    classes += params.green && params.isDisabled ? 'greenDisabled ' : ''
    classes += params.purple && params.isDisabled ? 'purpleDisabled ' : ''
    classes += params.red && params.isDisabled ? 'redDisabled ' : ''

    //--- Fim variaveis 


    return (
            <ButtonAdvanced
                className={classes}
                onClick={params.click}
                disabled={params.isDisabled ? params.isDisabled : false}
                text={params.nextText ? params.nextText : 'Continuar'}>
            </ButtonAdvanced>
    )
}

export default NextButton